/**
 * @generated SignedSource<<74970d134884c108424d483b9e3e8d0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveITPValue_charge$data = {
  readonly company: {
    readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveValue_company">;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentType": "PaymentActiveITPValue_charge";
};
export type PaymentActiveITPValue_charge$key = {
  readonly " $data"?: PaymentActiveITPValue_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITPValue_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveITPValue_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueWithDiscount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentLinkActiveValue_company"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "e1515bddf48999c0fdd26b06af785168";

export default node;
